export function isValidPhoneNumber(phoneNumber: string) {
    // const phonePattern = /^\+?\d{1,4}?[-.\s]?$?\d{1,3}$?[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/;
    // return phonePattern.test(phoneNumber);
    return phoneNumber.length >= 10;
}
